/* ag-v88.js - AquaGrip CT (v88, 27 Oct 2026, Claude). Loaded after ag-v86.js.
   "Customer builds" photo wall (CSS in ag-v88.css; the lightbox wiring is in
   ag-v81.js, which marks the grid .agv-wall).
   - Bento layout from the photo count on a 4-column grid, chosen so the wall
     closes square: first photo 2x2, then tall/wide accents (10 photos: #4 tall,
     #6 + #9 wide; 9 photos: adds #7 tall). Phones: 2 columns, first photo
     2x2, last one full width when the count needs it.
   - Pointer tilt + light sheen that follows the cursor (mouse/trackpad only).
   - Photos rise in, staggered, when the wall scrolls into view. */
(function(){
  'use strict';
  if(window.__agv88) return; window.__agv88 = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ACCENTS = [[4, 'w-tall'], [6, 'w-wide'], [9, 'w-wide'], [7, 'w-tall'], [3, 'w-wide']];
  var EXPAND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';

  function build(grid){
    if(grid.__agw) return; grid.__agw = true;
    var figs = Array.prototype.filter.call(grid.children, function(f){ return f.querySelector && f.querySelector('img'); });
    var n = figs.length; if(!n) return;
    figs.forEach(function(f, i){
      f.classList.remove('span-2', 'span-2x2');
      f.style.setProperty('--i', i);
      if(!f.querySelector('.agw-view')) f.insertAdjacentHTML('beforeend', '<span class="agw-sheen" aria-hidden="true"></span><span class="agw-view" aria-hidden="true">' + EXPAND + 'View build</span>');
    });
    /* 4 columns: big first photo = 4 cells, the rest 1 each; add accents until the wall closes square */
    figs[0].classList.add('w-big');
    var extra = (4 - (n + 3) % 4) % 4;
    if(extra === 0 && n >= 9) extra = 4;
    ACCENTS.forEach(function(a){ if(extra > 0 && figs[a[0] - 1] && a[0] - 1 > 0){ figs[a[0] - 1].classList.add(a[1]); extra--; } });
    /* phones: 2 columns */
    if((n - 1) % 2 === 1) figs[n - 1].classList.add('m-wide');

    if(fine && !reduce){
      figs.forEach(function(f){
        var raf = 0, ev = null;
        f.addEventListener('mousemove', function(e){
          ev = e; if(raf) return;
          raf = requestAnimationFrame(function(){
            raf = 0; var r = f.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
            f.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); f.style.setProperty('--my', (y * 100).toFixed(1) + '%');
            f.style.setProperty('--ry', ((x - .5) * 6).toFixed(2) + 'deg'); f.style.setProperty('--rx', ((.5 - y) * 6).toFixed(2) + 'deg');
          });
        });
        f.addEventListener('mouseleave', function(){ f.style.setProperty('--rx', '0deg'); f.style.setProperty('--ry', '0deg'); });
      });
    }

    if(reduce) return;
    /* rise in once the wall is on screen: IntersectionObserver, plus a plain
       position check on load and scroll as a fallback, so the photos can
       never stay hidden */
    grid.classList.add('agw-ready');
    var io = null, done = false;
    function reveal(){
      if(done) return; done = true;
      if(io) io.disconnect();
      window.removeEventListener('scroll', check);
      grid.classList.add('is-in');
      setTimeout(function(){ grid.classList.add('is-done'); }, 700 + n * 60);
    }
    function check(){ var r = grid.getBoundingClientRect(); if(r.top < window.innerHeight * .9 && r.bottom > 0) reveal(); }
    if('IntersectionObserver' in window){
      io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) reveal(); }); }, {threshold:.12});
      io.observe(grid);
    }
    window.addEventListener('scroll', check, {passive:true});
    check();
  }

  var tries = 0;
  (function wait(){
    var walls = document.querySelectorAll('.ag-work .ag-work-grid.agv-wall');
    if(walls.length){ Array.prototype.forEach.call(walls, build); return; }
    if(document.querySelector('.ag-work .ag-work-grid') && ++tries < 60) setTimeout(wait, 100);
  })();
})();
